import {
  PMSmallNumber,
  PMSmallNumberCardEditSchema,
} from "@pimo/pimo-components/src/lib/pm-components";

import { isFieldEnabled } from "../../field-enabled";
import { DashboardCardContext } from "../context";

export function addRatioOfCompletedProjectsCard(ctx: DashboardCardContext) {
  const { view, language, getCardCopy } = ctx;

  const ratioOfCompletedProjectsComponent = view.addComponent({
    component: PMSmallNumber,
  });

  ratioOfCompletedProjectsComponent.mapLayoutProps(({ language }) => {
    return {
      componentId: "ratioOfCompletedProjectsComponent",
      labels: ["#ofProjects"],
      description: getCardCopy(language, "numberOfCompletedProjects")
        .description,
      title: getCardCopy(language, "completionOfProjects").title,
      editSchema: PMSmallNumberCardEditSchema,
    };
  });

  ratioOfCompletedProjectsComponent.mapState(({ dashboard }) => {
    return {
      showInfoIcon: false,
      showMenuIcon: false,
      title: getCardCopy(language, "completionOfProjects").title,
      number: `${dashboard?._calculated?.numberOfClosedProjects ?? 0}/${
        dashboard?.projects?.length ?? 0
      }`,
      description: getCardCopy(language, "numberOfCompletedProjects")
        .description,
    };
  });

  ratioOfCompletedProjectsComponent.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "completion", "itemReporting")
  );
}
